import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  const needsTargetAttrReplacement =
    data.link &&
    data.link.target !== '_blank' &&
    data.attr &&
    data.attr.target === '_blank';

  return {
    needed: needsTargetAttrReplacement,
    logData: {
      msg: 'data attr `target` should be copied to `link` object',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      data.link.target = '_blank';
    },
  };
};
